.mainPaper {
	width: 50%;
	width: 450px;
	padding: 40px;
	padding-right: 50px;
	padding-left: 50px;
	margin-top: 50px;
	margin-bottom: 50px;
	margin-left: auto;
	margin-right: auto;
}
.helperTextStyle {
	margin-top: 5px;
	text-align: left;
	font-size: 0.75rem;
	white-space: pre-wrap;
	background-color: #fdecea;
	padding: 6px 16px;
	font-family: Helvetica;
	display: flex;
	border-radius: 4px;
	padding-top: 6px 16px;
	letter-spacing: 0.01071em;
	box-shadow: none;
}

.inputLabel {
	color: black !important;
	font-family: Helvetica !important;
	letter-spacing: 0.01071em !important;
}
